module.exports = {

  trouble_shooting_events_tab_title: "Resolución de Problemas",
  trouble_shooting_events_tab_filter_by_last: "Más recientes",
  trouble_shooting_events_tab_filter_by_date: "Entre",
  trouble_shooting_events_tab_apply_filters: "Aplicar",

  trouble_shooting_events_tab_id: "ID",
  trouble_shooting_events_tab_server_time: "Fecha de lectura",
  trouble_shooting_events_tab_unit_time: "Fecha de reporte",

   trouble_shooting_events_tab_data_center: "Centro de Datos",
  trouble_shooting_events_tab_event_code: "Evento en Bruto",
  trouble_shooting_events_tab_event_name: "Nombre Evento",
  trouble_shooting_events_tab_heading: "Rumbo",
  trouble_shooting_events_tab_latitude: "Latitud",
  trouble_shooting_events_tab_longitude: "Longitud",
  trouble_shooting_events_tab_sequence_number: "Secuencia #",
  trouble_shooting_events_tab_speed: "Velocidad GPS",
  trouble_shooting_events_tab_trail: "Rastro",
  trouble_shooting_events_tab_unit_type: "Tipo de Unidad",
  trouble_shooting_events_tab_address: "Dirección",
  trouble_shooting_events_tab_records: "Registros",
  rouble_shooting_events_tab_load_error: "Error cargando los eventos troubleshooting",
  trouble_shooting_events_tab_date_range: "Por favor seleccione un rango de fechas valido",
  trouble_shooting_events_tab_voltage: "Voltaje",
  trouble_shooting_events_tab_raw_message: "Datos en Bruto",

  trouble_shooting_events_tab_maintenance_warnings: "Advertencias",
  trouble_shooting_events_tab_events: "Eventos",
  trouble_shooting_events_tab_user: "Usuario"
}
